import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { updateBrandEntities } from './brands.actions';
import { AppState } from '../../reducers';
import * as R from 'ramda';

export interface Brand {
  id: number;
  name: string;
}

export interface Brands {
  [key: number]: {
    byId: {
      [key: string]: Brand;
    };
  };
}

const initialState = Immutable.from<Brands>({});

export type BrandState = Brands & Immutable.ImmutableObject<Brands>;

export default function reduce(
  state: BrandState = initialState,
  action: Action
) {
  if (isType(action, updateBrandEntities)) {
    const {
      payload: { appId, brands },
    } = action;
    return state.merge(
      {
        [appId]: {
          byId: brands,
        },
      },
      { deep: true }
    );
  }

  return state;
}

export function getBrandById(state: AppState, appId: number, id: number) {
  const {
    entities: { brands },
  } = state;

  return brands && brands[appId] && brands[appId].byId[id];
}

export function getBrandsByIds(
  state: AppState,
  appId: number,
  ids: number[]
): Brand[] {
  const {
    entities: { brands },
  } = state;

  return brands && brands[appId] && ids.map(id => brands[appId].byId[id]);
}

export function getBrandsByAppId(state: AppState, appId: number) {
  const {
    entities: { brands },
  } = state;

  return brands[appId] && R.values(brands[appId].byId);
}



// WEBPACK FOOTER //
// ./src/store/Entities/Brands/brands.reducer.ts